'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    ShareActionCreators = require('../actions/ShareActionCreators'),
    ImagePicker = require('../organisms/ImagePicker'),
    Share = require('../molecules/Share'),
    ServiceTypes = require('../constants/ServiceTypes'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    UserStore = require('../stores/UserStore'),
    getZineThumbnail = require('../utils/getZineThumbnail'),
    getZineCover = require('../utils/getZineCover'),
    ContentEditable = require('../atoms/ContentEditable'),
    ResponsiveImageQueueMixin = require('../mixins/ResponsiveImageQueueMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    formatCount = require('../utils/formatCount'),
    pluralize = require('../utils/pluralize'),
    Icon = require('../atoms/Icon'),
    FontTest = require('../atoms/FontTest'),
    UserLink = require('../atoms/UserLink'),
    UserImage = require('../atoms/UserImage'),
    ZineStatus = require('../constants/ZineStatus'),
    isBestOf2014Special = require('../utils/isBestOf2014Special');

require('./ZineCover.less');

const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

var THUMBNAIL_SIZE = 10 * 16 * Math.round(devicePixelRatio);

var ZineCover = React.createClass({
  mixins: [
    ClassNameMixin, PureRenderMixin, BackColorMixin, ResponsiveImageQueueMixin,
    createStoreMixin(UserStore),
    ScreenSizeMixin
  ],

  propTypes: {
    zine: React.PropTypes.object.isRequired,
    isEditing: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function() {
    return {
      isEditing: false
    };
  },

  getStateFromStores(props) {
    return {
      recentContributors: (props.zine.recentContributors || []).map(UserStore.get),
      isMeCurator: UserStore.isMe(props.zine.curator)
    };
  },

  getCSSModifiers() {
    var zine = this.props.zine;

    return [
      this.getTextColor(zine.backColor),
      this.props.isEditing && 'editing',
      isBestOf2014Special(zine) && '2014special'
    ];
  },

  getImageSizes() {
    return {
      'default': 480,
      'xs': 640,
      'sm': 992,
      'md': 1200,
      'lg': 1440,
      'xl': 1600
    };
  },

  /**
   * Specifies progressive loading options for zine covers.
   *
   * For zines we curate, we only load *one* highres image (either normal or retina).
   * This ensures instant switching between editing and viewing.
   *
   * For zines we don't curate, we load smaller thumbnails too to make loading appear faster.
   */
  getImageOptions() {
    var zine = this.props.zine,
        isMeCurator = this.state.isMeCurator,
        cover = getZineCover(zine);

    if (cover.isDefault) {
      return;
    }

    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: cover,
      sizes: {
        thumb: !isMeCurator,
        small: !isMeCurator,
        normal: devicePixelRatio <= 1.5,
        retina: devicePixelRatio > 1.5
      }
    };
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.zine.recentContributors !== this.props.zine.recentContributors) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  componentDidUpdate(prevProps) {
    if (prevProps.zine.coverUrl !== this.props.zine.coverUrl) {
      this.updateImageQueue();
    }
  },

  /**
   * Returns cover style when viewing a zine.
   * For default covers, return them as is (they're SVG anyway).
   * For custom covers, use progressively loaded sequence specified in `getImageQueue`.
   */
  getCoverStyle() {
    if (this.props.isEditing) {
      return;
    }

    var zineCover = getZineCover(this.props.zine);
    if (zineCover.isDefault) {
      return {
        backgroundImage: 'url(' + zineCover.url + ')',
        backgroundSize: 'auto'
      };
    } else {
      return {
        backgroundImage: this.getBackgroundImageUrl(),
        backgroundSize: 'cover'
      };
    }
  },

  /**
   * Returns cover URL when editing a zine, if you're a curator.
   * For default covers, we want it empty.
   * For custom covers, we want the only loaded image to avoid flicker (see `getImageOptions`).
   */
  getCoverPickerImageUrl() {
    var zineCover = getZineCover(this.props.zine);
    if (zineCover.isDefault) {
      return;
    }

    var normalOrRetinaUrl = this.getImageSrcUrl();
    return normalOrRetinaUrl;
  },

  /**
   * Returns thumbnail style when viewing a zine.
   * Default or not, it will be resized and cropped to a prefedined size.
   */
  getThumbnailStyle() {
    if (this.props.isEditing) {
      return;
    }

    var zineThumbnail = getZineThumbnail(this.props.zine),
        thumbnailUrl;

    thumbnailUrl = getThumbnailUrl(zineThumbnail, {
      mode: 'scale_crop',
      width: THUMBNAIL_SIZE,
      height: THUMBNAIL_SIZE
    });

    return {
      backgroundImage: 'url(' + thumbnailUrl + ')'
    };
  },

  /**
   * Returns thumbnail URL when editing a zine.
   * For default thumbnails, we want it empty.
   * For custom thumbnails, we want it resized and cropped to a prefedined size.
   */
  getThumbnailPickerUrl() {
    var zineThumbnail = getZineThumbnail(this.props.zine);
    if (zineThumbnail.isDefault) {
      return;
    }

    return getThumbnailUrl(zineThumbnail, {
      mode: 'scale_crop',
      width: THUMBNAIL_SIZE,
      height: THUMBNAIL_SIZE
    });
  },

  render() {
    var zine = this.props.zine,
        title = zine.title,
        description = zine.description,
        recentContributors = this.state.recentContributors,
        isUnlisted = zine.status === ZineStatus.UNLISTED,
        titleFontFamily = isBestOf2014Special(zine) ? 'playfair-display' : null;

    return (
      <div className={this.getClassName()}
           style={{ backgroundColor: '#' + zine.backColor }}>

        <div className='ZineCover-header'>
          <div className='ZineCover-coverImage'
               style={this.getCoverStyle()}>

            {this.renderLoaderImg()}

            {this.props.isEditing &&
              <ImagePicker imageUrl={this.getCoverPickerImageUrl()}
                           size='cover'
                           onUploadSuccess={this.handleCoverUploaded}
                           cancelOnChange>
                <Icon name='poster'
                      size='large'
                      mode='stroke'
                      context='ZineCover'/>
              </ImagePicker>
            }
          </div>
        </div>

        <div className='ZineCover-info'>
          <div className='ZineCover-avatar'
               style={this.getThumbnailStyle()}>

            {this.props.isEditing &&
              <ImagePicker imageUrl={this.getThumbnailPickerUrl()}
                           size='thumbnail'
                           onUploadSuccess={this.handleThumbnailUploaded}
                           cancelOnChange>
                <Icon name='image'
                      size='medium'
                      mode='stroke' />
              </ImagePicker>
            }
          </div>
          <div className='ZineCover-hgroup'>
            <FontTest family={titleFontFamily}
                      test={title}>
              <ContentEditable className='ZineCover-title'
                               component='h3'
                               onChange={this.handleZineTitleChange}
                               placeholder='Name Your Collection'
                               editable={this.props.isEditing}
                               text={title}
                               maxLength={40} />
            </FontTest>
            <FontTest family='minion-pro-condensed'
                      test={description}>
              <ContentEditable className='ZineCover-description'
                               component='p'
                               onChange={this.handleZineDescriptionChange}
                               placeholder='Add a description'
                               editable={this.props.isEditing}
                               text={description}
                               maxLength={200} />
            </FontTest>
            {isBestOf2014Special(zine) &&
              <Share services={[ServiceTypes.FACEBOOK, ServiceTypes.TWITTER]}
                     onShareClick={this.handleShareClick}
                     color='light'
                     size='medium'
                     showServiceName={!this.state.isMobile}
                     showShareWordPrefix={!this.state.isMobile} />
            }

            {!isBestOf2014Special(zine) && !this.props.isEditing && !isUnlisted &&
              this.renderFollowers()
            }
          </div>

          {!this.props.isEditing && recentContributors.length > 0 &&
            this.renderContributors(recentContributors)
          }
        </div>
      </div>
    );
  },

  renderFollowers() {
    var zine = this.props.zine;

    return (
      <div className='ZineCover-followers'>
        {formatCount(zine.subscriberCount)}
        {' '}
        {pluralize(zine.subscriberCount, 'Follower', 'Followers')}
      </div>
    );
  },

  renderContributors(recentContributors) {
    var items = recentContributors.map(user =>
      <li className='ZineCover-recentContributors-listItem'
          key={user.id}>
        <UserLink user={user} showTitle>
          <UserImage size='xsmall' user={user} />
        </UserLink>
      </li>
    );

    return (
      <div className='ZineCover-recentContributors'>
        <h3 className='ZineCover-recentContributors-label utils--smallCaps'>
          Recent contributors
        </h3>
        <ul className='ZineCover-recentContributors-list'>
          {items}
        </ul>
      </div>
    );
  },

  handleThumbnailUploaded(filePath, image) {
    ZineActionCreators.updateZineDraft('thumbnailUrl', image.url);
  },

  handleCoverUploaded(filePath, image) {
    ZineActionCreators.updateZineDraft('coverUrl', image.url);
  },

  handleZineTitleChange(textContent) {
    ZineActionCreators.updateZineDraft('title', textContent);
  },

  handleZineDescriptionChange(textContent) {
    ZineActionCreators.updateZineDraft('description', textContent);
  },

  handleShareClick(service) {
    ShareActionCreators.shareZine({
      source: AnalyticsSources.BEST_OF_2014_SPECIAL,
      zineSlug: this.props.zine.slug,
      service: service
    });
  }
});

module.exports = ZineCover;



/** WEBPACK FOOTER **
 ** ./molecules/ZineCover.jsx
 **/